var map = {
	"./Ncc.png": 65,
	"./addressImage.svg": 128,
	"./blogsImage.svg": 129,
	"./codeInLogo.png": 130,
	"./contactMail.png": 131,
	"./embedded.png": 132,
	"./experience.svg": 133,
	"./githubLogo.png": 134,
	"./jnvLogo.png": 135,
	"./kkLogo.png": 136,
	"./nielit.png": 137,
	"./opencvLogo.png": 138,
	"./postmanLogo.png": 139,
	"./projectsImage.svg": 140,
	"./ramanujanLogo.png": 141,
	"./ratnesh.png": 142,
	"./rustLogo.png": 143,
	"./talksCardBack.svg": 144,
	"./udacityLogo.png": 145,
	"./upythonWithMicro.png": 146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;